export default "__VITE_ASSET__fa7851da__"